import styled from 'styled-components';
import {dFlex, dFlexColumn, flexWrap, alignCenter, justifyCenter, justifyStart} from '../../../globalVariables/GlobalFlex';
import {ButtonStyled, getFontSize, getFontWeight, getPrimitive, getSpacing, getToken} from '@tickchak/react-share/app';

export const feedbackSection = styled.div`
    ${dFlex}
    ${flexWrap}
    ${alignCenter}
    ${justifyCenter}
    gap: ${getSpacing('spaceMd')};
    padding: ${getSpacing('spaceXl')} 0 ${getSpacing('spaceXl')};
    width: 100%;
`;

export const feedbackText = styled.div`
    ${dFlexColumn}
    ${alignCenter}
    text-align: center;
    
    strong {
        font-size: ${getFontSize('body')};
        font-weight: ${getFontWeight('bold')};
        line-height: ${getToken('typography.lineHeight.body')};
        color: ${getToken('color.text.default')};
    }
    
    span {
        font-size: ${getFontSize('body')};
        font-weight: ${getFontWeight('regular')};
        line-height: ${getToken('typography.lineHeight.body')};
        color: ${getToken('color.text.default')};
    }
`;

export const wrapAll = styled.div<{$isOpen: boolean}>`
    ${dFlexColumn}
    width: 370px;
    max-width: 100%;
    height: ${props => props.$isOpen ? '100%' : '0'};
    overflow: hidden;
    transition: height 0.3s;
    gap: ${getSpacing('spaceSm')};
    padding: 0;
    padding-top: ${getSpacing('spaceLg')};
    border-top: ${props => props.$isOpen ? '1px solid ' + getToken('color.border.subtle') : 'none'};
`;

export const feedbackSectionText = styled.div`
    ${dFlexColumn}
    width: 100%;
    gap: ${getSpacing('spaceSm')};
    align-items: flex-start;
`;

export const title = styled.h3`
    font-size: ${getFontSize('bodySmall')};
    font-weight: ${getFontWeight('semibold')};
    color: ${getToken('color.text.default')};
    margin: 0;
    text-align: start;
`;

export const wrapAllTextarea = styled.div`
    width: 100%;
    textarea {
        width: 100%;
        height: 120px;
        min-height: 120px;
        border: 1px solid ${getToken('color.border.subtle')};
        border-radius: ${getSpacing('spaceMd')};
        padding: 9px 14px;
        resize: vertical;
        overflow: hidden;
        font-family: inherit;
        font-size: ${getFontSize('caption')};
        font-weight: ${getFontWeight('regular')};
        color: ${getToken('color.text.subtle')};
        background: white;
        box-sizing: border-box;
        text-align: start;
        white-space: pre-wrap;
        
        &::placeholder {
            color: ${getToken('color.text.subtle')};
        }
        
        &:focus {
            outline: none;
            border-color: ${getToken('color.border.default')};
        }
    }
`;

export const buttons = styled.div`
    inset-inline-end: unset;
    width: 100%;
    padding-top: 0;
    border-top: none;
    ${dFlex}
    gap: ${getSpacing('spaceMd')};
    ${justifyStart}
    margin-top: ${getSpacing('spaceSm')};
    ${ButtonStyled.StyledButton} {
        width: 50%;
    }
`;
export const feedback = styled.div`
    ${dFlexColumn}
    ${alignCenter}
    width: 100%;
    
`;
export const successMessage = styled.div`
    ${dFlex}
    height: 53px;
    ${justifyCenter}
    ${alignCenter}
    gap: ${getSpacing('spaceSm')};
    border-radius: ${getSpacing('spaceMd')};
    border: 1px solid ${getToken('color.state.success.bg')};
    background: ${getPrimitive('greens.green50')};
    color: ${getToken('color.state.success.main')};
    font-size: ${getFontSize('bodySmall')};
    font-weight: ${getFontWeight('bold')};
    svg {
        height: 32px;
    }
`;